import { ITEM_DEFS, ItemId } from '../items/ItemDefs';

/** HTML overlay: hearts, held-item silhouette, transient hint. No in-world text. */
export class Hud {
  readonly root: HTMLDivElement;
  private heartsEl: HTMLDivElement;
  private heldEl: HTMLDivElement;
  private hintEl: HTMLDivElement;
  private heartEls: HTMLDivElement[] = [];
  private lastHearts = -1;
  private lastHeld: ItemId | null | undefined = undefined;
  private hintTimer = 0;

  constructor(parent: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'hud';
    this.heartsEl = document.createElement('div');
    this.heartsEl.className = 'hearts';
    this.heldEl = document.createElement('div');
    this.heldEl.className = 'held';
    this.heldEl.style.display = 'none';
    this.hintEl = document.createElement('div');
    this.hintEl.className = 'hint';
    this.root.append(this.heartsEl, this.heldEl, this.hintEl);
    parent.appendChild(this.root);
  }

  setVisible(v: boolean): void { this.root.style.display = v ? '' : 'none'; }

  hearts(n: number, max: number): void {
    if (this.heartEls.length !== max) {
      this.heartsEl.innerHTML = '';
      this.heartEls = [];
      for (let i = 0; i < max; i++) {
        const h = document.createElement('div');
        h.className = 'heart';
        this.heartsEl.appendChild(h);
        this.heartEls.push(h);
      }
      this.lastHearts = -1;
    }
    if (n === this.lastHearts) return;
    const lost = n < this.lastHearts;
    this.heartEls.forEach((h, i) => {
      h.classList.toggle('empty', i >= n);
      h.classList.toggle('wobble', n === 1 && i === 0);
      if (lost && i === n) { h.classList.remove('hit'); void h.offsetWidth; h.classList.add('hit'); }
      if (!lost && this.lastHearts >= 0 && i >= this.lastHearts && i < n) { h.classList.remove('hit'); void h.offsetWidth; h.classList.add('hit'); }
    });
    this.lastHearts = n;
  }

  held(id: ItemId | null): void {
    if (id === this.lastHeld) return;
    this.lastHeld = id;
    if (!id) { this.heldEl.style.display = 'none'; return; }
    this.heldEl.style.display = '';
    this.heldEl.innerHTML = ITEM_DEFS[id].icon;
    this.heldEl.classList.remove('pop'); void this.heldEl.offsetWidth; this.heldEl.classList.add('pop');
  }

  /** Show a short hint (e.g. a key glyph). Pass null to hide. */
  hint(text: string | null, seconds = 2): void {
    if (!text) { this.hintEl.classList.remove('show'); this.hintTimer = 0; return; }
    if (this.hintEl.textContent !== text) this.hintEl.textContent = text;
    this.hintEl.classList.add('show');
    this.hintTimer = seconds;
  }

  update(dt: number): void {
    if (this.hintTimer > 0) {
      this.hintTimer -= dt;
      if (this.hintTimer <= 0) this.hintEl.classList.remove('show');
    }
  }
}
